import { render } from "./PostHeaderAddComment.vue?vue&type=template&id=453e2fc4"
import script from "./PostHeaderAddComment.vue?vue&type=script&lang=js"
export * from "./PostHeaderAddComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__